/**
 * GamePlanAgent — Football-only flow that opens the inline
 * `CoachSteveGamePlanForm`. For other sports we politely redirect to the
 * practice plan flow.
 */

import { isCreateGamePlanIntent } from './intents';
import type { AgentRunContext, AgentRunResult, CoachSteveAgent } from './types';

export const gamePlanAgent: CoachSteveAgent = {
  name: 'gamePlan',
  description:
    "Opens the AI game-plan form for Football teams. Other sports are redirected to the practice plan flow.",
  applicableSports: ['Football'],
  match: (text) => isCreateGamePlanIntent(text),
  async handle(_text, ctx: AgentRunContext): Promise<AgentRunResult> {
    if (ctx.team.sport === 'Football') {
      await ctx.handleQuickAction('game_plan');
    } else {
      ctx.addMessage(
        'assistant',
        "Game plans are only for Football. I can help with a **practice plan** — just ask to create one."
      );
    }
    return { kind: 'handled' };
  },
};
